<template>
  <div class="withdrawal-container">
    <el-form ref="form"
             :rules="rules"
             :model="form"
             label-position="top"
             label-width="80px">
      <!--账户选择-->
      <el-form-item :label="$t('withdrawal.tradeAccount')"
                    prop="tradeAccount">
        <bAccountNumbersSelect v-model="form.tradeAccount"
                               ref='AccountNumbers'
                               test_id="btn_trade_account"
                               @change="tradeAccountChange" />
      </el-form-item>
      <!--本地出金银行卡号-->
      <el-form-item :label="$t('withdrawal.bank_card_number')"
                    prop="bank_card_number">
        <el-select v-model="bank_card_number"
                   test_id="btn_bank_card"
                   @change="bankCardChange"
                   :placeholder="$t('withdrawal.please_sel')">
          <el-option-group v-for="(group, key) in bankCardNumber"
                           :test_id="'withdrawal_bank_'+ group.number"
                           :key="key"
                           :label="group.label">
            <div v-for="(item,groupkey) in group.options"
                 :key="item.value">
              <div v-if="item.groupList"
                   class="label-item">
                <div class="name-box"
                     @click.stop="clickArrow(item, groupkey)"><span>{{item.name}}</span><i
                     :class="item.clickVisible?'el-icon-arrow-up':'el-icon-arrow-down'"></i></div>
                <div v-show="item.clickVisible">
                  <el-option class="account-box"
                             v-for="(groupItem, index) in item.groupList"
                             :key="index"
                             :value="groupItem.text">
                    <span>{{ groupItem.account }} ({{ groupItem.currency }})</span>
                  </el-option>
                </div>
              </div>
              <div v-else
                   class="common-box"
                   :class="type!=='STOCK'?'ordinary-box':''">
                <el-option v-if="item.number==='other'"
                           :value="item.number"
                           :label="item.label"><span class="common-box-text">{{item.label}}</span></el-option>
                <el-option v-else
                           :value="item.labelValue"
                           :label="item.label"><span class="common-box-text">{{item.label}}</span></el-option>
              </div>
            </div>
          </el-option-group>
        </el-select>
      </el-form-item>
      <!--其他银行名称-->
      <!-- <el-form-item   :label="$t('withdrawal.other_bank_card_name')" prop="other_bank_card_name"  v-show="bank_card_number==='other'">
              <el-input v-model="form.bank_card_name" :placeholder="$t('withdrawal.other_bank_card_name_placeholder')"></el-input>
            </el-form-item> -->
      <el-form-item :label="$t('withdrawal.other_bank_card_name')"
                    prop="other_bank_card_name"
                    v-show="bank_card_number==='other'">
        <el-select v-model="bank_card"
                   value-key="code"
                   filterable
                   @change="bankNameChange"
                   :placeholder="$t('withdrawal.please_sel')">
          <el-option v-for="(value, index) in allOtherBanks"
                     class="other-banks"
                     :key="index"
                     :label="value.bankName"
                     :value="value">{{value.bankName}}</el-option>
        </el-select>
      </el-form-item>
      <!--其他银行账号-->
      <el-form-item :label="$t('withdrawal.other_bank_card_number')"
                    prop="other_bank_card_number"
                    v-show="bank_card_number==='other'">
        <el-input v-model="form.bank_card_number"
                  :placeholder="$t('withdrawal.other_bank_card_number_placeholder')"></el-input>
      </el-form-item>
      <!--外汇账户余额-->
      <div v-if="type === 'FOREX'">
        <el-form-item :label="$t('withdrawal.acceptableAmount')"
                      class="input_currency">
          <img @click="helpDialog=true"
               class="help-box"
               src="@/assets/images/help.png"
               alt="">
          <el-input placeholder=""
                    readonly
                    :disabled="true"
                    class="input_aomut">
            <template slot="prepend">USD</template>
            <div slot="prefix"
                 class="money-icon">${{formatUSDBalance}}</div>
          </el-input>
        </el-form-item>
      </div>
      <!--证券/期货账户余额-->
      <div v-if="type !== '' && type!=='FOREX'">
        <el-form-item :label="$t('withdrawal.availableAmount')"
                      class="input_currency">
          <el-input placeholder=""
                    readonly
                    :disabled="true"
                    class="input_aomut">
            <template slot="prepend">HKD</template>
            <div slot="prefix"
                 class="money-icon">${{formatHKDBalance}}</div>
          </el-input>
          <el-input placeholder=""
                    readonly
                    :disabled="true"
                    class="input_aomut line-space-input">
            <template slot="prepend">USD</template>
            <div slot="prefix"
                 class="money-icon">${{formatUSDBalance}}</div>
          </el-input>
          <el-input placeholder=""
                    readonly
                    :disabled="true"
                    class="input_aomut line-space-input">
            <template slot="prepend">CNY</template>
            <div slot="prefix"
                 class="money-icon">¥{{formatCNYBalance}}</div>
          </el-input>
        </el-form-item>
      </div>
      <!--取款金额-->
      <el-form-item :label="$t('withdrawal.withdrawal_amount')"
                    prop="withdrawal_amount"
                    ref='withdrawalAmount'>
        <el-input type="number"
                  :min='min'
                  placeholder=""
                  v-model="form.withdrawal_amount"
                  test_id="input_withdrawal_amount"
                  class="input_aomut">
          <template slot="prepend">{{withdrawalAmountCurrency}}</template>
          <div slot="prefix"
               class="money-icon">$</div>
        </el-input>
      </el-form-item>
      <div class="service-charge">
        <span class="charge-left">{{ $t("withdrawal.unhkServiceFee") }}</span>
        <span class="charge-right" v-if="curChargeInfo.businessCcy && curChargeInfo.businessCcy !== curChargeInfo.ccy">
          ≈ {{ this.serviceCharge.toFixed(2) }} {{ withdrawalAmountCurrency }}
          ({{curChargeInfo.amount}} {{curChargeInfo.ccy}})
        </span>
        <span class="charge-right" v-else>{{ this.serviceCharge.toFixed(2) }} {{ withdrawalAmountCurrency }}</span>
      </div>
      <!--上传图片-->
      <el-form-item>
        <div class="tips-font-style"
             v-if="type === 'FOREX' || type === 'PM'">{{$t('withdrawal.withdrawalTips.uploadTips.mt5Tip')}}</div>
        <div class="tips-font-style"
             v-else>{{$t('withdrawal.withdrawalTips.uploadTips.tip1')}}</div>
      </el-form-item>
      <el-form-item v-show="bank_card_number==='other'"
                    :label="$t('withdrawal.withdrawalTips.uploadTips.uploadTitle')"
                    prop="checkUpload">
        <uploadPicture ref="uploadPicture"
                       @uploadHandle="uploadHandle"></uploadPicture>
      </el-form-item>
      <el-form-item class="text-center">
        <el-button class="submit-primary-btn"
                   test_id="button_submit"
                   :loading="subLoading"
                   type="primary"
                   @click="submitFn('form')">
          {{$t('withdrawal.button_submit')}} </el-button>
      </el-form-item>
    </el-form>
    <el-dialog :title="$t('withdrawal.acceptableAmount')"
               class="help-dialog"
               :visible.sync="helpDialog"
               width="30%"
               :before-close="handleClose">
      <p>{{$t('withdrawal.largestAmount')}}</p>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import uploadPicture from './uploadPicture'
import api1 from '@/api/v2/withdrawal'
import tradeApi from '@/api/v2/trade'
import { getHandingCharge } from '@/api/v2/fund'
export default {
  components: { uploadPicture },

  computed: {
    ...mapGetters(['getUser', 'valueAccountNumber', 'getClientProfile', 'getAccountInfo']),
    HKDBalance () {
      if (!this.cashList.length) return 0
      console.log(this.cashList, 'this.cashList')
      if (!this.cashList.find(item => item.currency === 'HKD')) return 0
      return this.cashList.find(item => item.currency === 'HKD').amount
    },
    USDBalance () {
      if (!this.cashList.length) return 0
      if (!this.cashList.find(item => item.currency === 'USD')) return 0
      if (this.type !== 'FOREX') {
        return this.cashList.find(item => item.currency === 'USD').amount
      } else {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.mt5Amount = this.cashList.find(item => item.currency === 'USD').amount
        console.log(this.mt5Amount, '------------this.mt5Amount')
        return this.cashList.find(item => item.currency === 'USD').maxAmount || this.mt5Amount
      }
    },
    CNYBalance () {
      console.log(this.tradeAccountType, 'this.tradeAccountType>>>')
      if (!this.cashList.length) return 0
      if (this.tradeAccountType === 'futuresMargin') {
        if (!this.cashList.find(item => item.currency === 'CNH')) return 0
        return this.cashList.find(item => item.currency === 'CNH').amount
      } else {
        if (!this.cashList.find(item => item.currency === 'CNY')) return 0
        return this.cashList.find(item => item.currency === 'CNY').amount
      }
    },
    formatHKDBalance () {
      return (this.HKDBalance.toFixed(2) + '').replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,')
    },
    formatUSDBalance () {
      return (this.USDBalance.toFixed(2) + '').replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,')
    },
    formatCNYBalance () {
      return (this.CNYBalance.toFixed(2) + '').replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,')
    },
    withdrawalAmountCurrency () {
      let bnakcurrency = ''
      console.log(this.bank_card_number, 'this.bank_card_number11111111')
      if (this.bank_card_number && this.bank_card_number.indexOf('(')) {
        let arr = this.bank_card_number.split('(')
        let arrs = arr[arr.length - 1].split(')')
        console.log(arrs)
        bnakcurrency = arrs[0]
      }
      if (!['USD', 'HKD', 'CNY'].includes(bnakcurrency)) {
        bnakcurrency = 'HKD'
      }
      if (['FOREX', 'PM'].includes(this.type)) {
        return 'USD'
      } else {
        return bnakcurrency || 'HKD'
      }
    },
    serviceCharge() {
      let serviceCharge = 0
      this.chargeInfoList.forEach(item => {
        if (item.businessCcy === this.withdrawalAmountCurrency && item.accountType === this.type) {
          serviceCharge = item.exchangeAmount
        }
      })
      return serviceCharge
    },
    curChargeInfo() {
      let curChargeInfo = {}
      this.chargeInfoList.forEach(item => {
        if (item.businessCcy === this.withdrawalAmountCurrency && item.accountType === this.type) {
          curChargeInfo = item
        }
      })
      return curChargeInfo
    }
  },
  props: {
    cashList: {
      type: Array,
      default: () => []
    },
    bankCardNumber: {
      type: Array,
      default: () => []
    },
    allOtherBanks: {
      type: Array,
      default: () => []
    }
  },
  data () {
    var checkInputBlance = (rule, value, callback) => {
      var reg = /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/
      const flagBalanceObj = {
        STOCK: this[`${this.withdrawalAmountCurrency}Balance`],
        FUTURES: this[`${this.withdrawalAmountCurrency}Balance`],
        FOREX: this.type === 'FOREX' ? this.mt5Amount : this.USDBalance,
        PM: this.USDBalance,
        FUND: this[`${this.withdrawalAmountCurrency}Balance`]
      }
      const flagBalance = flagBalanceObj[this.type] ? flagBalanceObj[this.type] : 0
      console.log(flagBalance, 'flagBalance', this.totalAmount, 'this.showBalance')
      if (!value) {
        callback(new Error(this.$t('withdrawal.error_withdrawal_amount_1')))
      } else if (this.type !== 'FOREX' && +value > +this.totalAmount) {
        callback(new Error(this.$t('withdrawal.error_withdrawal_amount') + this.withdrawalAmountCurrency + ' ' + this.Util.formatCurrency(this.totalAmount)))
      } else if (+value > +flagBalance && this.type === 'FOREX') {
        callback(new Error(this.$t('withdrawal.error_withdrawal_amount_mt5')))
      } else if (+this.form.withdrawal_amount < 0.01) {
        callback(new Error(this.$t('withdrawal.error_withdrawal_amount_2')))
      } else if (!reg.test(value)) {
        callback(new Error(this.$t('withdrawal.error_withdrawal_amount_3')))
      } else {
        callback()
      }
    }
    var checkInputAccountNum = (rule, value, callback) => {
      if (!this.form.tradeAccount || this.form.tradeAccount === '') {
        callback(new Error(this.$t('withdrawal.error_account_number')))
      } else {
        callback()
      }
    }
    var checkBankCardNumber = (rule, value, callback) => {
      if (!this.bank_card_number) {
        callback(new Error(this.$t('withdrawal.error_bank_card_number')))
      }
      callback()
    }
    var checkOtherBankCardNumber = (rule, value, callback) => {
      console.log('sksksksksks')
      let reg = /^[0-9-*]{1,}$/
      if (this.bank_card_number === 'other' && !this.form.bank_card_number) {
        callback(new Error(this.$t('withdrawal.error_bank_card_number')))
      } else if (this.bank_card_number === 'other' && !reg.exec(this.form.bank_card_number)) {
        callback(new Error(this.$t('withdrawal.irregular_rules_bank_card_number')))
      }
      callback()
    }
    var checkOtherBankCardName = (rule, value, callback) => {
      if (this.bank_card_number === 'other' && !this.form.bank_card_name) {
        callback(new Error(this.$t('withdrawal.error_bank_card_name')))
      } else if (this.bank_card_number === 'other' && !this.form.bank_card_name.trim()) {
        callback(new Error(this.$t('withdrawal.irregular_rules_bank_card_name')))
      }
      callback()
    }
    let checkOtherBankImageKeys = (rule, value, callback) => {
      if (this.bank_card_number === 'other' && !this.imageKeys.length) {
        callback(new Error(this.$t('withdrawal.imageKeysIsRequired')))
      }
      callback()
    }
    return {
      min: 0,
      imageKeys: [],
      type: '',
      subLoading: false,
      bank_card_number: '',
      bank_card: '',
      form: {
        tradeAccount: '',
        bank_card_number: '',
        withdrawal_amount: '',
        bankType: '',
        bank_card_code: ''
      },
      feeInfo: {},
      tradeAccountType: '',
      rules: {
        tradeAccount: [
          {
            required: true,
            validator: checkInputAccountNum,
            trigger: 'change'
          }
        ],
        bank_card_number: { required: true, validator: checkBankCardNumber, trigger: 'change' },
        other_bank_card_number: { required: true, validator: checkOtherBankCardNumber, trigger: 'change' },
        other_bank_card_name: { required: true, validator: checkOtherBankCardName, trigger: 'change' },
        withdrawal_amount:
        {
          validator: checkInputBlance,
          required: true,
          // message: this.$t('withdrawal.error_withdrawal_amount_1'),
          trigger: ['change', 'blur']
        },
        checkUpload: { required: true, validator: checkOtherBankImageKeys, trigger: 'change' }
      },
      helpDialog: false,
      mt5Amount: 0,
      totalAmount: 0,
      tradeAccountTypeReal: '',
      chargeInfoList: []
    }
  },
  watch: {
    // withdrawalAmountCurrency: {
    //   handler: function (val) {
    //     this.getActiveManageFee()
    //   },
    //   immediate: true
    // }
  },
  mounted() {
    this.getHandingCharge()
  },
  methods: {
    getHandingCharge() {
      let param = {
        businessType: 'LOCAL_WITHDRAWAL'
      }
      getHandingCharge(param).then(res => {
          if (res.code === 200) {
            this.chargeInfoList = res.data
          }
      })
    },
    bankCardChange (val) {
      this.form.withdrawal_amount = ''
      if (val === 'other') {
        this.form.bank_card_number = ''
        this.form.bank_card_name = ''
        this.form.bankType = 'OTHER'
      } else {
        this.form.bank_card_number = val
        this.form.bankType = 'SETTLEMENT_ACCOUNT'
      }
      if (this.type === 'STOCK' || this.type === 'FUND') {
        if (!this.cashList.length || !this.cashList.find(item => item.currency === this.withdrawalAmountCurrency)) {
          this.totalAmount = 0
        } else {
          this.totalAmount = this.cashList.find(item => item.currency === this.withdrawalAmountCurrency).maxAmount || 0
        }
      } else {
        // this.getActiveManageFee()
        this.getTotalAmount()
      }
      this.bankCardNumber.map((item, index) => {
        item.options.map((value, key) => {
          if (value.labelValue === val && value.isForbidWithdrawal) {
            this.bank_card_number = ''
            this.form.bank_card_number = ''
            this.form.bank_card_name = ''
            this.$emit('showDialog')
          }
          if (value.groupList && value.groupList.length) {
            value.groupList.map(valueItem => {
              if (valueItem.text === val && valueItem.isForbidWithdrawal) {
                this.bank_card_number = ''
                this.form.bank_card_number = ''
                this.form.bank_card_name = ''
                this.$emit('showDialog')
              }
            })
          }
        })
      })
      for (const value of this.bankCardNumber) {
        if (value.number === val) {
          this.form.bank_card_name = value.name
          break
        }
      }
    },
    async getActiveManageFee () {
      let params = {
        currency: this.withdrawalAmountCurrency,
        type: this.type,
        tradeAccountNumber: this.form.tradeAccount,
        feeType: 'WITHDRAWAL',
        amount: this.form.withdrawal_amount
      }
      let res = await api1.getActiveManageFee(params)
      if (res && res.code === 200) {
        this.feeInfo = res.data ? res.data : {}
        // this.feeInfo = {
        //   activeManageFee: 100,
        //   currency: 'HKD',
        //   financeCurrency: 'HKD',
        //   financeFee: 1500,
        //   isNeedFee: true,
        //   isNeedFeeFinance: true
        // }
      } else {
        this.feeInfo = {}
      }
    },
    getTotalAmount () {
      let params = {
        currency: this.withdrawalAmountCurrency,
        type: this.tradeAccountTypeReal,
        tradeAccountNumber: this.form.tradeAccount
      }
      tradeApi.getTotalAmount(params).then(res => {
        let data = res.data ? res.data : {}
        this.totalAmount = data.amount ? data.amount : 0
      })
    },
    bankNameChange (val) {
      console.log(val, 'val>>>')
      this.form.bank_card_code = val.code
      this.form.bank_card_name = val.bankName
    },
    uploadHandle (imageKeys) {
      this.imageKeys = imageKeys
    },
    submitFn (formName) {
      const self = this
      this.subLoading = true
      this.$refs[formName].validate(async (valid, error) => {
        self.subLoading = false
        if (!valid) return
        console.log(this.mt5Amount, this.form.withdrawal_amount, this.USDBalance, '----')
        // 外汇 [建议最大可提金额]<[取款金额]≤“可用预付款” 需提示强平风险
        let isNeedPoint = false
        // if (this.type === 'FOREX') {
        //   if (Number(this.USDBalance) < Number(this.form.withdrawal_amount) && Number(this.form.withdrawal_amount) <= Number(this.mt5Amount)) {
        //     isNeedPoint = true
        //   } else {
        //     isNeedPoint = false
        //   }
        // } else {
        //   isNeedPoint = false
        // }
        this.$emit('isNeedPointFun', isNeedPoint)
        self.form = {
          ...self.form,
          serviceCharge: this.serviceCharge,
          accountFee: 0,
          currency: this.withdrawalAmountCurrency
          // actualAmount: self.form.withdrawal_amount
        }
        await this.getActiveManageFee()
        // 仅有账户管理费
        if (self.feeInfo.isNeedFee && !self.feeInfo.isNeedFeeFinance) {
          self.form.accountFee = self.feeInfo.activeManageFee
          self.form.actualAmount = (self.form.withdrawal_amount - self.feeInfo.activeManageFee - self.serviceCharge) >= 0
            ? (Math.round(self.form.withdrawal_amount * 100) - Math.round(self.feeInfo.activeManageFee * 100) - Math.round(self.serviceCharge * 100)) / 100 : 0
          delete self.form.financeFee
        } else if (!self.feeInfo.isNeedFee && self.feeInfo.isNeedFeeFinance) {
          // 仅有一手融手续费
          self.form.financeFee = self.feeInfo.financeFee
          self.form.actualAmount = (self.form.withdrawal_amount - self.feeInfo.financeFee - self.serviceCharge) >= 0
            ? (Math.round(self.form.withdrawal_amount * 100) - Math.round(self.feeInfo.financeFee * 100) - Math.round(self.serviceCharge * 100)) / 100 : 0
          delete self.form.accountFee
        } else if (self.feeInfo.isNeedFee && self.feeInfo.isNeedFeeFinance) {
          // 账户管理费和一手融手续费都有
          self.form.accountFee = self.feeInfo.activeManageFee
          self.form.financeFee = self.feeInfo.financeFee
          self.form.actualAmount = (self.form.withdrawal_amount - self.feeInfo.financeFee - self.feeInfo.activeManageFee - self.serviceCharge) >= 0
            ? (Math.round(self.form.withdrawal_amount * 100) - Math.round(self.feeInfo.financeFee * 100) - Math.round(self.feeInfo.activeManageFee * 100) - Math.round(self.serviceCharge * 100)) / 100 : 0
        } else {
          self.form.actualAmount = (self.form.withdrawal_amount - self.serviceCharge) >= 0
            ? (Math.round(self.form.withdrawal_amount * 100) - Math.round(self.serviceCharge * 100)) / 100 : 0
          delete self.form.financeFee
          delete self.form.accountFee
        }
        console.log(self.form, 'self.form')
        self.$emit('submitFn', self.form, self.type, self.imageKeys)
      })
    },
    // 重置表单
    resetForm () {
      // 重置上传组件图片列表
      this.$refs.uploadPicture.clearImageKeys()
      // 重置交易账户选项
      this.$refs.AccountNumbers.resetAccount()
      this.type = ''
      this.bank_card_number = ''
      this.form = {
        ...{
          tradeAccount: '',
          bank_card_number: '',
          withdrawal_amount: ''
        }
      }
      this.$nextTick(() => {
        // 这里处理表单清空后不触发校验问题
        this.$refs.form.clearValidate()
      })
      this.$emit('resetWithdrawalForm', this.form, this.type, this.imageKeys)
    },
    async tradeAccountChange (tradeAccountObj) {
      this.form.tradeAccount = tradeAccountObj.value
      this.type = tradeAccountObj.type
      this.tradeAccountTypeReal = tradeAccountObj._tradeAccountType
      // if (tradeAccountObj.type !== 'STOCK') {
      // 清空银行卡号
      this.bank_card_number = ''
      this.form.bank_card_number = ''
      // }
      this.tradeAccountType = tradeAccountObj.tradeAccountType
      this.tradeAccountTypeReal = tradeAccountObj._tradeAccountType
      // this.getActiveManageFee()
      await this.$emit('getAccountNumber', tradeAccountObj)
      this.form.withdrawal_amount = ''
    },
    handleClose () {
      this.helpDialog = false
    },
    clickArrow (val, key) {
      console.log(key, 'key')
      this.$set(
        this.bankCardNumber[0].options[key],
        'clickVisible',
        !this.bankCardNumber[0].options[key].clickVisible
      )
    }
  }
}
</script>
<style lang="scss" scoped>
.withdrawal-container {
  .input_currency {
    position: relative;
    .help-box {
      position: absolute;
      top: -21px;
      left: 103px;
    }
  }
}
.help-dialog {
  /deep/.el-dialog__body {
    padding: 0 30px 30px;
  }
}
.label-item {
  display: flex;
  flex-direction: column;
  // padding: 0 20px;
  //   /deep/.el-select-dropdown__item{
  //   height: auto;
  //   padding: none !important;
  // }
  .name-box {
    display: flex;
    padding: 5px 20px;
    justify-content: space-between;
    // padding-left: 20px;
    // padding-right: 20px;
  }

}
.account-box span{
  padding: 0 20px;
}

/deep/.el-select-group__wrap:last-of-type {
  .el-select-group {
    padding: 0;
  }
}
/deep/.el-select-group__wrap:first-of-type {
  .el-select-group {
    padding: 0 20px !important;
  }
}
.el-icon-arrow-down {
  font-size: 15px;
  color: #fec000;
  font-weight: 700;
}
.el-icon-arrow-up {
  @extend .el-icon-arrow-down;
}
.common-box-text{
  padding: 5px 20px;
}
.name-box {
  padding: 10px 0;
  color: #606266;
  font-size: 14px;
  cursor: pointer;
}
/deep/.el-select-dropdown__item {
  padding: 0 !important;
}
/deep/.el-select-group .el-select-dropdown__item {
  padding: 0 20px;
}
.common-box {
  padding: 0 20px;
}
.ordinary-box {
  padding: 0;
}
.other-banks {
  padding: 0 20px !important;
}
.service-charge {
  margin-bottom: 16px;
  .charge-left {
    font-size: 12px;
    color: #83909D
  }
  .charge-right {
    font-size: 14px;
    color: #1C212A;
    margin-left: 10px;
  }
}
</style>
